<template>
  <pf-dropdown container-ouia-id="currency-dropdown" :text="text">
    <pf-dropdown-item @click.prevent="updateCurrency('EUR')">
      EUR
    </pf-dropdown-item>
    <pf-dropdown-item @click.prevent="updateCurrency('CHF')">
      CHF
    </pf-dropdown-item>
  </pf-dropdown>
</template>

<script lang="ts" setup>
import { useLoginStore } from '@/store/login';
import { http } from '@/http';
import { computed } from 'vue';
import type Dropdown from '@vue-patternfly/core/components/Dropdown/Dropdown.vue';
import type { ComponentProps } from 'vue-component-type-helpers';

type DropdownProps = ComponentProps<typeof Dropdown>;

interface Props extends /* @vue-ignore */ Omit<DropdownProps, 'text'> {
  prefix?: string;
}

const props = defineProps<Props>();

const text = computed(() => {
  const login = useLoginStore();
  if (!props.prefix) {
    return login.currency;
  }
  return `${props.prefix}: ${login.currency}`;
});

async function updateCurrency(currency: 'EUR' | 'CHF') {
  const data = new FormData();
  data.append('currency', currency);
  await http.post('/api/currency/update', data);

  const login = useLoginStore();
  login.currency = currency;
}
</script>
